<template>
    <div id="userList">
        <div class="searchContent">
            <div class="p_select">
                <a  class="back_btn" @click="back"><i class="el-icon-back"></i>返回</a>
            </div>
            <div class="p_select">
                <a  class="add_btn" @click="addItem"><i class="el-icon-plus"></i>新增</a>
            </div>
        </div>
        <div class="list_content">

            <div style="height: 30px;padding: 24px 0;"><span>字典名称：{{this.rowData.dictionaryName}} </span></div>

            <el-table :data="devicelistData" :height=winHeight>
                <el-table-column prop="dictionaryItemId" align="left" label="itemID"></el-table-column>
                <el-table-column prop="text" align="left" label="名称"></el-table-column>
                <el-table-column prop="orderIndex" align="left" label="排序字段"></el-table-column>

                <el-table-column label="默认值" align="left">
                    <template slot-scope="scope">
                        <el-switch
                                v-model='scope.row.isDefault'
                                active-color="#ff4949"
                                inactive-color="#13ce66"
                                active-value="0"
                                inactive-value="1"
                                @change="changeSwitchDefault(scope.row.isDefault,scope.row)"
                        ></el-switch>
                    </template>
                </el-table-column>

                <el-table-column label="状态" align="left">
                    <template slot-scope="scope">
                        <span v-if="scope.row.isUsing == 1" style="color: #13ce66">启用</span>
                        <span v-if="scope.row.isUsing == 0" style="color: #ff4949">禁用</span>
                    </template>
                </el-table-column>

                <el-table-column fixed="right" label="操作" align="left">
                    <template slot-scope="scope">
                        <el-button
                                @click="updateDictionItem(scope.row)"
                                class="update_btn"
                                size="small"
                        >修改</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <el-drawer
                title="新增字典item"
                :visible.sync="showAddData"
                direction="rtl"
                :wrapperClosable=true
                @close="noAddData">
            <el-form ref="form" :model="dicItemForm" label-width="100px">
                <el-form-item label="名称:" required>
                    <el-input v-model="dicItemForm.text"></el-input>
                </el-form-item>
                <el-form-item label="排序字段:" required>
                    <el-input v-model="dicItemForm.orderIndex"  type="number" onmousewheel="this.value=this.value.replace(/\D/g,'')" onkeyup="this.value=this.value.replace(/\D|^/g,'')" onafterpaste="this.value=this.value.replace(/\D|^0/g,'')"></el-input>
                </el-form-item>
            </el-form>
            <div class="position_box_btn">
                <a class="sure_btn" @click="submitAdd">确认新增</a>
                <a class="cancel_btn" @click="noAddData">取消</a>
            </div>
        </el-drawer>
        <el-drawer
                title="修改字典item"
                :visible.sync="showEditData"
                direction="rtl"
                :wrapperClosable=true
                @close="noUpdateData">
            <el-form ref="form" :model="dicItemForm" label-width="100px">
                <el-form-item label="ID:">
                    <el-input v-model="dicItemForm.dictionaryItemId" disabled></el-input>
                </el-form-item>
                <el-form-item label="名称:" required>
                    <el-input v-model="dicItemForm.text"></el-input>
                </el-form-item>
                <el-form-item label="排序字段:" required>
                    <el-input v-model="dicItemForm.orderIndex"  type="number" onmousewheel="this.value=this.value.replace(/\D/g,'')" onkeyup="this.value=this.value.replace(/\D|^/g,'')" onafterpaste="this.value=this.value.replace(/\D|^0/g,'')"></el-input>
                </el-form-item>
                <el-form-item label="状态:">
                    <el-switch
                            v-model="dicItemForm.isUsing"
                            active-value='1'
                            inactive-value='0'
                            active-color="#13ce66"
                            inactive-color="#ff4949"
                            active-text="启用"
                            inactive-text="禁用"
                    ></el-switch>
                </el-form-item>
            </el-form>
            <div class="position_box_btn">
                <a class="sure_btn" @click="SubmitUpdate">保存修改</a>
                <a class="cancel_btn" @click="noUpdateData">取消</a>
            </div>
        </el-drawer>


    </div>
</template>

<script>
  import net from "../../assets/js/public";
  export default {
    data() {
      return {
        devicelistData:[],
        rowData:'',
        showEditData: false,
        showAddData: false,
        dicItemForm:{
          text: '',
          orderIndex: '',
          isUsing:'',
        },
        winHeight:'200'


      };
    },
    created() {
      var signInfo = JSON.parse(sessionStorage.getItem("signInfo"));
      var rowData = JSON.parse(sessionStorage.getItem("dictionaryListDetail"));
      this.orgId = signInfo.orgId;
      this.rowData = rowData
      this.getListData()

    },
    methods: {
      getListData() {
        net.request("admin/manage/gather/normal/dictionary/typeValueList","post",null,{dictionaryId:this.rowData.dictionaryId}).then(res => {
          if (res.retcode === 1) {
            for (var i = 0; i < res.data.length; i++) {
              res.data[i].isDefault += ""
              res.data[i].isUsing += ""

              const windiwHight = document.documentElement.clientHeight || document.body.clientHeight // 可视屏幕高度
              this.winHeight = windiwHight - 300
            }
            this.devicelistData = res.data
          } else {
            net.message(this, "获取数据失败", "warning");
          }
        })
      },
      addItem(){
        this.showAddData = true
        this.dicItemForm.text = ''
        this.dicItemForm.orderIndex = ''
      },
      submitAdd(){
        if(this.dicItemForm.text == '' || this.dicItemForm.text == null || this.dicItemForm.orderIndex == '' || this.dicItemForm.orderIndex == null ){
          net.message(this, '必填项不能为空', "error");
          return
        }
        let list = []
        list.push({
          dictionaryId:this.rowData.dictionaryId,
          text: this.dicItemForm.text,
          orderIndex: this.dicItemForm.orderIndex * 1,
        })
        let params = {
          dictionaryId: this.rowData.dictionaryId,
          list:list
        }

        net.request("admin/manage/gather/normal/dictionary/addValueForType", "post", null, params).then(res => {
          if (res.retcode === 1) {
            net.message(this, res.retmsg, "success");
            this.getListData()
          } else {
            net.message(this, res.retmsg, "warning");
          }
          this.showAddData = false
          this.getListData()
        });
      },
      noAddData(){
        this.showAddData = false
        this.getListData()
      },
      // 修改
      updateDictionItem(row){
        this.showEditData = true
        this.dicItemForm = row
      },
      SubmitUpdate(){
        if(this.dicItemForm.text == '' || this.dicItemForm.text == null || this.dicItemForm.orderIndex == '' || this.dicItemForm.orderIndex == null ){
          net.message(this, '必填项不能为空', "error");
          return
        }
        const params = {
          dictionaryId: this.rowData.dictionaryId,
          dictionaryItemId: this.dicItemForm.dictionaryItemId,
          text: this.dicItemForm.text,
          orderIndex: this.dicItemForm.orderIndex,
          isUsing: this.dicItemForm.isUsing == true ? 1 : 0,
        }
        net.request("admin/manage/gather/normal/dictionary/editValueForType", "post",null,params).then(res => {
          if (res.retcode === 1) {
            net.message(this, res.retmsg, "success");
            this.showEditData = false
            this.getListData()
          } else {
            net.message(this, res.retmsg, "warning");
          }
        })
      },
      noUpdateData(){
        this.showEditData = false
        this.getListData()
      },
      // 是否默认
      changeSwitchDefault(status, data){
        const params = {
          dictionaryId: data.dictionaryId,
          dictionaryItemId: data.dictionaryItemId
        }
        net.request("admin/manage/gather/normal/dictionary/setItemDefault", "post",params).then(res => {
          if(res.retcode === 1){
            net.message(this, res.retmsg, "success");
            this.getListData()
          }else {
            net.message(this, res.retmsg, "warning");
          }
        })
      },
      back(){
        let href = '/dictionaryList'
        this.$router.push({ path: href });
      },
    },
    computed: {

    },
  };
</script>


<style lang="less" scoped>
    /deep/ .el-table th.el-table__cell {
        background: #F3F7FB !important;
        color: #364556;
    }
    #userList {
        padding-left: 24px;
        .searchContent {
            height: 60px;
            background: #fff;
            margin: 24px 0 0px 0;
            padding-left: 24px;
            padding-top: 24px;
            border-radius: 8px;
            .p_select {
                display: flex;
                padding: 0 24px 24px 0;
                font-size: 12px;
                float: left;
                .search_label{
                    font-family: 'PingFang SC';
                    font-style: normal;
                    margin-right: 12px;
                    font-weight: 500;
                    font-size: 14px;
                    line-height: 40px;
                    color: #787E86;
                    white-space:nowrap
                }

                .el-input , .el-select{
                    width: 160px;
                }
            }
            .back_btn{
                width: 84px;
                height: 36px;
                text-align: center;
                line-height: 36px;
                background: rgba(255, 255, 255, 0.08);
                border: 1px solid #E3E7ED;
                border-radius: 4px;
                font-size: 14px;
                color: #364556;
            }
            .search_btn {
                width: 76px;
                height: 36px;
                line-height: 36px;
                background: #2B54FC;
                box-shadow: 0px 4px 12px rgba(71, 134, 192, 0.24);
                border-radius: 4px;
                color: #FFFFFF;
                font-size: 14px;
            }
            .add_btn {
                width: 76px;
                height: 36px;
                line-height: 36px;
                background: rgba(148, 170, 204, 0.08);
                border: 1px solid #2B54FC;
                border-radius: 4px;
                font-size: 14px;
                color: #2B54FC;
            }

        }
        .list_content {
            background: #fff;
            padding-left: 24px;
            padding-right: 24px;
            margin-top: 24px;
            border-radius: 8px;
        }
        .pagination {
            position: relative;
            margin-top: 0;
            background: #fff;
            padding-top: 24px;
            padding-bottom: 10px;
            .el-pagination {
                position: absolute;
                right: 24px;
                .el-pager li:not(.disabled) {
                    .active {
                        background: #009688 !important;
                    }
                }
            }
        }

        .el-pagination.is-background .el-pager li:not(.disabled).active {
            background: #009688;
        }
        .update_btn {
            width: 54px;
            height: 28px;
            background: rgba(148, 170, 204, 0.08);
            border: 1px solid #E3E7ED;
            border-radius: 14px;
            font-size: 12px;
            color: #364556;
            text-align: center;
        }
    }
    .orgLabelSet {
        width: 660px;
        // background-color: red;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
    }
    .orgLabel {
        width: 220px;
        padding-top: 5px;
        padding-bottom: 5px;
        text-align: left;
    }
    .el-input , .el-select{
        width: 100%;
    }
</style>
